import React, { useState } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import logo from "./logo.png";

function Navigation() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const toggleMobileNav = () => setMobileNavOpen((prev) => !prev);
  const closeMobileNav = () => setMobileNavOpen(false);

  const NavLink = ({ to, children, onClick }) => {
    if (isHomePage) {
      return (
        <ScrollLink
          to={to}
          smooth={true}
          offset={-70}
          className="cursor-pointer hover:text-blue-600"
          onClick={onClick}
        >
          {children}
        </ScrollLink>
      );
    }
    return (
      <RouterLink
        to={`/#${to}`}
        className="cursor-pointer hover:text-blue-600"
        onClick={onClick}
      >
        {children}
      </RouterLink>
    );
  };

  return (
    <nav className="fixed w-full bg-white shadow-sm z-50">
      <div className="px-4 md:px-8 py-4">
        <div className="flex items-center justify-between md:justify-between">
          <RouterLink to="/" className="flex items-center gap-2">
            <img src={logo} alt="PillPal" className="h-8 w-8 object-contain" />
            <span className="text-xl font-bold">Pill Pal</span>
          </RouterLink>
          <button
            className="md:hidden flex flex-col justify-center items-center gap-1 p-2"
            onClick={toggleMobileNav}
            aria-label="Toggle navigation menu"
          >
            {[0, 1, 2].map((line) => (
              <span key={line} className="block h-0.5 w-6 bg-gray-900"></span>
            ))}
          </button>
          {/* Desktop Navigation - always visible on desktop */}
          <div className="hidden md:flex md:items-center md:flex-1 md:justify-center md:gap-6">
            <ul className="flex gap-6">
              <li>
                <NavLink to="features">Features</NavLink>
              </li>
              <li>
                <NavLink to="how-it-works">How It Works</NavLink>
              </li>
              <li>
                <NavLink to="contact">Contact</NavLink>
              </li>
              <li>
                <RouterLink to="/about" className="cursor-pointer hover:text-blue-600">
                  About
                </RouterLink>
              </li>
            </ul>
          </div>
          {/* Desktop Button - always visible on desktop */}
          <div className="hidden md:block">
            {isHomePage ? (
              <ScrollLink to="contact" smooth={true} offset={-70}>
                <button className="bg-gray-200 px-4 py-2 rounded-lg hover:bg-gray-300">
                  Get in Touch
                </button>
              </ScrollLink>
            ) : (
              <RouterLink to="/">
                <button className="bg-gray-200 px-4 py-2 rounded-lg hover:bg-gray-300">
                  Get in Touch
                </button>
              </RouterLink>
            )}
          </div>
        </div>
        {/* Mobile Navigation - hidden/shown based on state */}
        <div
          className={`mt-4 flex-col md:hidden ${
            mobileNavOpen ? "flex" : "hidden"
          }`}
        >
          <ul className="flex flex-col gap-4">
            <li>
              <NavLink to="features" onClick={closeMobileNav}>
                Features
              </NavLink>
            </li>
            <li>
              <NavLink to="how-it-works" onClick={closeMobileNav}>
                How It Works
              </NavLink>
            </li>
            <li>
              <NavLink to="contact" onClick={closeMobileNav}>
                Contact
              </NavLink>
            </li>
            <li>
              <RouterLink
                to="/about"
                className="cursor-pointer hover:text-blue-600"
                onClick={closeMobileNav}
              >
                About
              </RouterLink>
            </li>
          </ul>
          {isHomePage ? (
            <ScrollLink
              to="contact"
              smooth={true}
              offset={-70}
              className="w-full mt-4"
              onClick={closeMobileNav}
            >
              <button className="w-full bg-gray-200 px-4 py-2 rounded-lg hover:bg-gray-300">
                Get in Touch
              </button>
            </ScrollLink>
          ) : (
            <RouterLink
              to="/"
              className="w-full mt-4"
              onClick={closeMobileNav}
            >
              <button className="w-full bg-gray-200 px-4 py-2 rounded-lg hover:bg-gray-300">
                Get in Touch
              </button>
            </RouterLink>
          )}
        </div>
      </div>
    </nav>
  );
}

export default Navigation;

